export const KEYBOARD_KEY = {
  ENTER: 'Enter',
  BACKSPACE: 'Backspace',
  ESCAPE: 'Escape',
  SPACE: ' ',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
} as const

export const DOM_EVENT = {
  MOUSEDOWN: 'mousedown',
  KEYDOWN: 'keydown',
  OFFLINE: 'offline',
  ONLINE: 'online',
  TOUCHSTART: 'touchstart',
  TOUCHEND: 'touchend',
} as const
